import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Chift\SyncCompanyAccountingCode::__invoke
* @see app/Http/Controllers/Chift/SyncCompanyAccountingCode.php
* @route '/api/company/{company}/chift/sync-accounting-code'
*/
const SyncCompanyAccountingCode = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SyncCompanyAccountingCode.url(args, options),
    method: 'get',
})

SyncCompanyAccountingCode.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/chift/sync-accounting-code',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Chift\SyncCompanyAccountingCode::__invoke
* @see app/Http/Controllers/Chift/SyncCompanyAccountingCode.php
* @route '/api/company/{company}/chift/sync-accounting-code'
*/
SyncCompanyAccountingCode.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return SyncCompanyAccountingCode.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Chift\SyncCompanyAccountingCode::__invoke
* @see app/Http/Controllers/Chift/SyncCompanyAccountingCode.php
* @route '/api/company/{company}/chift/sync-accounting-code'
*/
SyncCompanyAccountingCode.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SyncCompanyAccountingCode.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Chift\SyncCompanyAccountingCode::__invoke
* @see app/Http/Controllers/Chift/SyncCompanyAccountingCode.php
* @route '/api/company/{company}/chift/sync-accounting-code'
*/
SyncCompanyAccountingCode.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SyncCompanyAccountingCode.url(args, options),
    method: 'head',
})

export default SyncCompanyAccountingCode